import List from '../components/list.js';
import { useState, useContext, useEffect, useRef } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import Dialog from '../components/dialog.jsx';
import SponsorCard from '../components/sponsor-card.js'
import { SortableContainer } from '../components/sortable.jsx'
import { Link } from 'react-router-dom';
import axios from 'axios';

const SponsorList = () => {
    const [sponsors, setSponsors] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const { role, metaData } = useContext(AccessContext);
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [activeSponsors, setActiveSponsors] = useState([]);
    const [podcastId, setPodcastId] = useState(0);
    const dialogRef = useRef(null);
    setContext('Sponsors');
    const headings = [
        { key: 'id', name: 'ID' },
        { key: 'name', name: 'Name', link: true, linkKey: 'id' },
        { key: 'type', name: 'Type' },
        { key: 'active', name: 'Status', center: true }
    ]
    const loadSponsors = (page) => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'sponsor', {
            page: page,
            search: search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setTotalRecords(r.data.total);
                setSponsors(r.data.results.map(res => {
                    res.isActive = !!res.active;
                    res.active = res.active ? <span style={{color: 'green'}}>{'\u2714'}</span> : <span style={{color: 'red'}}>{'\u2716'}</span>;
                    return res;
                }));
                axios.post(process.env.REACT_APP_API_URL + 'podcast').then(r => {
                    if (r?.data?.status === 'Success') {
                        setActiveSponsors(r.data.results.sponsors.map(s => {
                            s.type = s.type == 0 ? 'Banner' : 'Video';
                            return s;
                        }));
                        setPodcastId(r.data.results.id);
                    }
                });
            }
        });
    }
    const deleteSponsors = () => {
        let toDelete = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.ids.push(sponsors[i].id);
                acc.urls.push(sponsors[i].mediaUrl);
            }
            return acc
        }, { ids: [], urls: [] });
        if (toDelete.ids.length === 0)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'sponsor/delete', {
            ids: JSON.stringify(toDelete.ids),
            urls: JSON.stringify(toDelete.urls)
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadSponsors(currentPage);
                setChecks(Array.apply(null, Array(sponsors?.length)).map(() => false));
            }
        });
    }
    const addSponsorsToPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(sponsors[i].id);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        setSponsors([]);
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'sponsor/update/podcast-connection', {
            ids: ids,
            add: true
        }).then(r => {
            setLoading(false);
            loadSponsors(currentPage);
            setChecks(Array.apply(null, Array(sponsors?.length)).map(() => false));
        });
    }
    const removeSponsorsFromPodcast = () => {
        let ids = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.push(sponsors[i].id);
            }
            return acc
        }, []);
        if (ids.length === 0)
            return;
        setSponsors([]);
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + 'sponsor/update/podcast-connection', {
            ids: ids,
            add: false
        }).then(r => {
            setLoading(false);
            loadSponsors(currentPage);
            setChecks(Array.apply(null, Array(sponsors?.length)).map(() => false));
        });
    }
    useEffect(() => {
        loadSponsors(0);
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(sponsors?.length)).map(() => false));
    }, [sponsors]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <Dialog ref={dialogRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        dialogRef.current.hide();
                    }}>Close</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        <SortableContainer containerClass="w-100 gap-10 card-container flex full-height" items={activeSponsors}
                            onOrderChange={(newList) => {
                                setActiveSponsors(newList);
                                axios.post(process.env.REACT_APP_API_URL + 'rank/update', {
                                    ids: JSON.stringify(newList.map(m => m.id)),
                                    ranks: JSON.stringify(newList.map((m, i) => i + 1)),
                                    type: 'podcastsponsor',
                                    id: podcastId
                                })
                            }}
                            itemClass="w-100"
                            renderItem={(m, i) => (
                                <SponsorCard sponsor={m} key={i} />
                            )} />
                    </div>
                </div>
            </Dialog>
            <div className="container w-100">
                <div className="form mb-10">
                    <div className="w-100 f-row gap-10">
                        <Link to="/sponsor" className="btn btn-green">Add Sponsor</Link>
                    </div>
                    <div className="mw-300 w-100 gap-10 f-row">
                        <button className="link-styles" onClick={deleteSponsors}>Delete</button>
                        {role != "Host/Guest" && (
                            <>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={addSponsorsToPodcast}>Publish</button>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={removeSponsorsFromPodcast}>Unpublish</button>
                                <button className="link-styles" style={{whiteSpace: 'nowrap'}} onClick={() => dialogRef.current.show()}>Publish Order</button> 
                            </>
                        )}
                    </div>
                    <div className="mw-300 w-100 ml-auto gap-10 f-row f-end">
                        <input type="search" placeholder="Search Sponsors" value={search} onChange={(e) => setSearch(e.target.value)} />
                        <button className="btn" onClick={() => { setCurrentPage(0); loadSponsors(0)}}> Search</button>
                    </div>
                </div>
                <List list={sponsors} href="sponsor" headings={headings} loading={loading} onCheck={setChecks} actions={role == "Host/Guest" ? undefined : [{
                    text: (e) => {
                        return !e.isActive ? 'Publish' : 'Unpublish'
                    },
                    action: (e) => {
                        setLoading(true);
                        setSponsors([]);
                        axios.post(process.env.REACT_APP_API_URL + 'sponsor/update/podcast-connection', {
                            ids: [e.id],
                            add: !e.isActive
                        }).then(r => {
                            setLoading(false);
                            loadSponsors(currentPage);
                        });
                    }
                }]} />
                <div className="list-arrows">
                    {currentPage > 0 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadSponsors(currentPage - 1);
                            setCurrentPage(c => c - 1);
                        }}>{'\u2039'}</button>
                    )}
                    {pages.map(p => (
                        <button key={p} className={"btn btn-squared" + (p == currentPage ? ' current-page' : '')} onClick={() => {
                            loadSponsors(p);
                            setCurrentPage(p);
                        }}>{p + 1}</button>
                    ))}
                    {(currentPage + 1) * pageSize < totalRecords - 1 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadSponsors(currentPage + 1);
                            setCurrentPage(c => c + 1);
                        }}>{'\u203A'}</button>
                    )}
                </div>
            </div>
        </main>
    )
}

export default SponsorList;